import React from 'react';
import { Reorder } from 'motion/react';
import { FullProject as Project } from '../../types';
import { isProjectEditableByUser } from '../../utils/projectPermissions';
import { ProjectSidebarItem } from './SidebarItem';
import { SidebarProjectListProps } from './types';

const GLOBAL_NON_PROJECT_VIEWS = ['dashboard', 'metricsDashboard', 'globalKanban', 'communication', 'impactEffort', 'noDateTasks', 'globalCalendar', 'aiAssistant', 'projectPool', 'analysis'];

export const SidebarProjectList: React.FC<SidebarProjectListProps> = React.memo(({
  visibleProjects,
  activeWorkspace,
  isCollapsed,
  localActiveId,
  localViewMode,
  openMenuId,
  categories,
  currentUserId,
  currentUserEmail,
  onReorderProjects,
  onSelect,
  onPrefetch,
  onMenuToggle,
  onDuplicateProject,
  onRenameProject,
  onArchiveToggle,
  onDeleteProject,
  onUpdateProjectCategory
}) => {
  return (
    <div className="flex-1 overflow-y-auto custom-scrollbar p-3 pt-4 pb-36 space-y-6">
      <div>
        {!isCollapsed && (
          <div className="px-3 mb-3 flex items-center gap-2 justify-start">
            <h3 className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">
              Projekte
            </h3>
            <span className="text-[9px] font-bold text-slate-400 dark:text-slate-500 bg-slate-200/50 dark:bg-slate-800 px-1.5 py-0.5 rounded-md">
              {visibleProjects.length}
            </span>
          </div>
        )}
        
        {/* Permanent "Nicht zugeordnet" / Inbox item */}
        {activeWorkspace === 'professional' && (
          <div className="mb-2">
            <ProjectSidebarItem
              project={{
                id: 'inbox_inforum',
                name: 'Nicht zugeordnet',
                color: 'bg-slate-500',
                tasks: [],
                workspace: 'professional',
                changelog: []
              } as any}
              isActive={localActiveId === 'inbox_inforum' && !GLOBAL_NON_PROJECT_VIEWS.includes(localViewMode)}
              isArchivedList={false}
              isCollapsed={isCollapsed}
              isDraggingOver={false}
              isOpen={false}
              onSelect={onSelect}
              onMenuToggle={() => {}}
              onDragOver={() => {}}
              onDragLeave={() => {}}
              onDrop={() => {}}
              onDuplicate={() => {}}
              onRename={() => {}}
              onArchiveToggle={() => {}}
              onDelete={() => {}}
              index={-1}
              listLength={1}
              categories={[]}
            />
          </div>
        )}

        <Reorder.Group 
          axis="y" 
          values={visibleProjects} 
          onReorder={onReorderProjects} 
          className="space-y-2"
        >
          {visibleProjects.map((project, index) => {
            const isReadOnly = !isProjectEditableByUser(project, currentUserId, currentUserEmail);

            const isItemActive = localActiveId === project.id && !GLOBAL_NON_PROJECT_VIEWS.includes(localViewMode);

            return (
              <Reorder.Item 
                key={project.id} 
                value={project}
                layout="position"
                className={`relative ${openMenuId === project.id ? 'z-[40]' : ''}`}
                initial={false}
                dragListener={!project.archived}
              >
                <ProjectSidebarItem
                  project={project}
                  isReadOnly={isReadOnly}
                  isActive={isItemActive}
                  isArchivedList={!!project.archived}
                  isCollapsed={isCollapsed}
                  isDraggingOver={false}
                  isOpen={openMenuId === project.id}
                  onSelect={onSelect}
                  onPrefetch={onPrefetch}
                  onMenuToggle={onMenuToggle}
                  onDragOver={() => {}}
                  onDragLeave={() => {}}
                  onDrop={() => {}}
                  onDuplicate={onDuplicateProject}
                  onRename={onRenameProject}
                  onArchiveToggle={(id) => onArchiveToggle(id, !!project.archived)}
                  onDelete={onDeleteProject}
                  index={index}
                  listLength={visibleProjects.length}
                  categories={categories}
                  onAssignCategory={onUpdateProjectCategory}
                />
              </Reorder.Item>
            );
          })}
        </Reorder.Group>
      </div>
    </div>
  );
});
